"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONFIG = void 0;
exports.CONFIG = {
  variables: {
    width: {
      medium: 800
    }
  },
  body: '[data-hook="body"]',
  returnToTop: {
    colors: {
      primary: 'rgb(131, 201, 191)'
    }
  },
  header: {
    wrapper: '[data-hook="header-wrapper"]',
    options: {
      offset: 215,
      tolerance: 5
    }
  },
  navigation: {
    wrapper: '[data-hook="body"]',
    main: '[data-hook="navigation"]',
    toggleButton: '[data-hook="toggleNavigationButton"]',
    toggleParent: '[data-hook="toggleNavigationParent"]',
    toggleSubMenuButton: '[data-hook="toggleSubMenuButton"]',
    wrapperClass: 'navigation-is-active',
    activeClass: 'is-active',
    navigationItem: '[data-hook="navigation-item"]'
  },
  heroLinks: {
    main: '[data-hook="hero-links"]',
    toggleButton: '[data-hook="toggleHeroLinksButton"]',
    toggleHeroLinkButton: '[data-hook="toggleHeroLinkButton"]',
    activeClass: 'is-active'
  },
  categoryLinks: {
    main: '[data-hook="category-links"]',
    toggleButton: '[data-hook="toggleCategoryLinksButton"]',
    toggleCategoryLinkButton: '[data-hook="toggleCategoryLinkButton"]',
    activeClass: 'is-active'
  },
  contentSet: {
    main: '[data-hook="content-set"]',
    options: {
      accessibility: true,
      adaptiveHeight: true,
      autoPlay: false,
      cellAlign: 'center',
      cellSelector: '.content-set-item',
      contain: true,
      draggable: true,
      dragThreshold: 10,
      freeScroll: true,
      friction: 0.2,
      groupCells: false,
      initialIndex: 0,
      lazyLoad: true,
      percentPosition: false,
      prevNextButtons: false,
      pageDots: false,
      resize: true,
      rightToLeft: false,
      setGallerySize: true,
      watchCSS: true,
      wrapAround: false
    }
  },
  imageGallery: {
    main: '[data-hook="image-gallery"]',
    options: {
      accessibility: true,
      adaptiveHeight: true,
      autoPlay: false,
      cellAlign: 'center',
      cellSelector: '.image-gallery-item',
      contain: true,
      draggable: true,
      dragThreshold: 10,
      freeScroll: false,
      selectedAttraction: .05,
      friction: 0.6,
      groupCells: false,
      initialIndex: 0,
      lazyLoad: true,
      percentPosition: false,
      prevNextButtons: true,
      pageDots: true,
      resize: true,
      rightToLeft: false,
      setGallerySize: true,
      watchCSS: false,
      wrapAround: false,
      fullscreen: true
    }
  },
  heroCarousel: {
    main: '[data-hook="hero-carousel"]',
    options: {
      accessibility: false,
      adaptiveHeight: false,
      autoPlay: false,
      cellAlign: 'center',
      cellSelector: '.hero-carousel-item',
      contain: true,
      draggable: true,
      dragThreshold: 10,
      freeScroll: false,
      selectedAttraction: .05,
      friction: 0.6,
      groupCells: false,
      initialIndex: 0,
      lazyLoad: true,
      percentPosition: false,
      prevNextButtons: true,
      pageDots: true,
      resize: true,
      rightToLeft: false,
      setGallerySize: true,
      watchCSS: false,
      wrapAround: false,
      fullscreen: false
    }
  },
  videoList: {
    main: '[data-hook="video-list"]',
    player: '[data-hook="video-player"]',
    playerTitle: '[data-title]',
    thumbnail: '[data-hook="video-thumbnail"]',
    videoWrapper: '.video-player',
    selectedClass: 'is-selected'
  },
  flowGrid: {
    grid: '[data-hook="masonry-grid"]',
    item: '[data-hook="masonry-item"]',
    itemContent: '[data-hook="masonry-content"]',
    flickityOptions: {
      accessibility: true,
      adaptiveHeight: false,
      autoPlay: false,
      cellAlign: 'center',
      cellSelector: '[data-hook="masonry-item"]',
      contain: true,
      draggable: true,
      dragThreshold: 10,
      freeScroll: false,
      selectedAttraction: .05,
      friction: 0.6,
      groupCells: false,
      initialIndex: 0,
      lazyLoad: true,
      percentPosition: false,
      prevNextButtons: false,
      pageDots: true,
      resize: false,
      rightToLeft: false,
      setGallerySize: true,
      watchCSS: true,
      wrapAround: false
    }
  },
  scrollDown: {
    trigger: '[data-hook="scroll-down"]',
    target: '[data-hook="scroll-target"]'
  },
  searchPopup: {
    wrapper: '[data-hook="search-popup-wrapper"]',
    trigger: '[data-hook="search-trigger"]',
    submit: '[data-hook="search-submit"]',
    searchForm: '#SearchForm_SearchForm',
    searchInput: 'input[name="Search"]',
    activeClass: 'is-active',
    placeholderText: 'Type Here...'
  },
  readMore: {
    main: '[data-hook="read-more"]',
    toggle: '[data-hook="more-less"]',
    truncatedText: '[data-hook="truncate-text"]',
    readMoreChar: '[data-read-more-after-chars]'
  },
  accordian: {
    main: '[data-hook="accordian"]',
    toggle: '[data-hook="accordian-item-title"]',
    item: '[data-hook="accordian-item"]',
    itemOuterWrapper: '[data-hook="accordian-item-outer-wrapper"]',
    itemInnerWrapper: '[data-hook="accordian-item-inner-wrapper"]',
    activeClass: 'is-active'
  },
  showMore: {
    main: '[data-hook="limit-visible-downloads]',
    toggle: '[data-hook="show-more-trigger"]',
    hiddenClass: 'hidden',
    visibleClass: 'show'
  },
  videoModal: {
    main: '[data-hook="video-modal"]',
    modalClass: 'modal',
    playerClass: '.video-player',
    close: '[data-hook="close"]'
  },
  teReoTitle: {
    main: 'h1 em, h2 em, h3 em, h4 em, h5 em, h6 em'
  }
};